/**
 * Heuristic classification for CPNU / Rama Judicial actuación rows.
 * Surfaces "estados electrónicos" and "traslados electrónicos" in the UI without extra DB columns.
 */

export type ActuacionKind = "estado" | "traslado" | "otro";

export interface ActuacionClassification {
  kind: ActuacionKind;
  label: string;
  shortLabel: string;
}

function foldDiacritics(s: string): string {
  return s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

/**
 * Classify a single timeline row from `actuacion` + optional `descripcion`.
 */
export function classifyActuacion(actuacion?: string | null, descripcion?: string | null): ActuacionClassification {
  const raw = `${actuacion ?? ""} ${descripcion ?? ""}`;
  const t = foldDiacritics(raw);

  const traslado =
    /traslad|traslado|remision del expediente|remision|envio del expediente|envio electron|traslado electron|cedula de traslado|comunicacion oficial|remision a|traslado a|traslado especial|traslado ordinario/.test(
      t
    );

  const estado =
    /estado electron|notificacion por estado|notificacion en linea|publicacion en estado|estados procesales|nomina electron|auto de estado|fijacion de estado|estado del proceso|estado procesal|publicacion procesal|notificacion electronica|actuacion de estado/.test(
      t
    ) || /\bestados?\s+n[°o]?\s*\d/.test(t);

  if (traslado) {
    return { kind: "traslado", label: "Traslado electrónico", shortLabel: "Traslado" };
  }
  if (estado) {
    return { kind: "estado", label: "Estado electrónico", shortLabel: "Estado" };
  }
  return { kind: "otro", label: "Actuación", shortLabel: "Actuación" };
}
